import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../redux/hooks";
import {
  getAllDefaulters,
  getDefaulters,
  getSingleCustomer,
} from "../redux/thunk";
import BVNVerificationModal from "../components/modals/BVNVerificationModal";
import { EMandateModal } from "../components/modals/EMandateModal";
import axios from "axios";
import { CardDebit } from "../components/modals/CardDebit";
import { RootState } from "../redux/store";
import { IoSearchOutline } from "react-icons/io5";
import { Preloader } from "../components/elements/Preloader";
import Pagination from "../components/Pagination";
import LoadingSpinner from "../components/elements/LoadingSpinner";
import { FaPhone, FaWhatsapp } from "react-icons/fa6";
import LoanInfo from "../components/modals/LoanInfo";

export const Defaulters = () => {
  const adminLevel = sessionStorage.getItem("adminLevel");
  const [bvnModalOpen, setBvnModalOpen] = useState(false);
  const [filter, setFilter] = useState("");
  const [selectedBvn, setSelectedBvn] = useState<any>([]);
  const [defaultersList, setDefaultersList] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [emandateModal, setEmandateModal] = useState(false);
  const [defaultAmount, setDefaultAmount] = useState("");
  const [allEmandate, setAllEmandate] = useState<any>([]);
  const [cardDebitModal, setCardDebitModal] = useState(false);
  const [allCards, setAllCards] = useState<any>([]);
  const [searchedUser, setSearchedUser] = useState<any>([]);
  const [showLoanDetails, setShowLoanDetails] = useState(false);
  const [loanDetails, setLoanDetails] = useState({});
  const [activeTab, setActiveTab] = useState("individual");
  const [itemsPerPage, setItemsPerPage] = useState(15);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalResults, setTotalResults] = useState(0);

  const [isLoadingEmandate, setIsLoadingEmandate] = useState<{
    [key: number]: Boolean;
  }>({});
  const [acctClick, setAcctClick] = useState({
    monoId: "",
    overdueAmount: "",
    accounts: [],
  });
  const { token } = useAppSelector((store: RootState) => store.auth);

  const fetchMandates = async () => {
    try {
      const res: any = await axios.get(
        `${process.env.REACT_APP_API_URL}/getActiveMandates
        `,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      setAllEmandate(res.data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleShowLoanInfo = (data: any) => {
    setShowLoanDetails(true);
    setLoanDetails(data);
  };

  const dispatch = useAppDispatch();

  const handleBvnClick = (id: any) => {
    dispatch(getSingleCustomer(id)).then((res: any) => {
      setSelectedBvn(res.payload.customer);
      setBvnModalOpen(true);
    });
  };

  const fetchCards = async (id: string) => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/getCardDetailsByUserId/${id}
        `,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      setAllCards(res.data.cardDetails);
    } catch (error: any) {
      console.error(error.message);
    }
  };

  const handleCardDebit = async (userId: string, defaultAmount: any) => {
    await fetchCards(userId);
    setCardDebitModal((prev) => !prev);
    setDefaultAmount(defaultAmount);
  };

  useEffect(() => {
    setIsLoading(true);
    const handler = setTimeout(() => {
      (async () => {
        try {
          const response: any = await dispatch(
            getDefaulters({
              page: currentPage,
              limit: itemsPerPage,
              categoryType: activeTab,
              search: searchedUser
            })
          );
          const res = response.payload;
          setDefaultersList(res?.data || []);
          setCurrentPage(res?.page || 1);
          setTotalPages(res?.totalPages || 1);
          setTotalResults(res?.total || 0);
          setItemsPerPage(res?.limit || 15);
        } finally {
          setIsLoading(false);
        }
      })();
    }, 500);

    return () => clearTimeout(handler);
  }, [activeTab, currentPage, dispatch, itemsPerPage, searchedUser]);

  const handleEmandate = async (
    monoId: string,
    amount: string,
    index: number
  ) => {
    setIsLoadingEmandate((prev) => ({ ...prev, [index]: true }));
    await fetchMandates().then(() =>
      setIsLoadingEmandate((prev) => ({ ...prev, [index]: false }))
    );
    setDefaultAmount(amount);
    setAcctClick((prev) => ({
      ...prev,
      monoId: monoId,
    }));
  };

  useEffect(() => {
    // Finds all mandates and defaulter info for the selected account,
    if (acctClick.monoId) {
      const acctArray = allEmandate.filter(
        (acct: any) => acct.customer === acctClick.monoId
      );
      const defaulterArray = defaultersList.filter(
        (acct: any) => acct.monoId === acctClick.monoId
      );

      setAcctClick((prev) => ({
        ...prev,
        accounts: acctArray,
        overdueAmount: defaulterArray[0].OverdueAmount,
      }));

      setEmandateModal((prev) => !prev);
    }
  }, [allEmandate, acctClick.monoId, defaultersList]);

  const searchForUsersWithEmail = (value: string) => {
    setSearchedUser(value);
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [searchedUser, filter, activeTab]);

  const prevPage = () => {
    if (currentPage > 1) {
      goToPage(currentPage - 1);
    }
  };

  const nextPage = () => {
    if (currentPage < totalPages) {
      goToPage(currentPage + 1);
    }
  };

  // Pagination
  const goToPage = async (pageNumber: any) => {
    setSearchedUser("");
    setCurrentPage(pageNumber);
  };

  const dataToDisplay = defaultersList;

  const finalFilteredData = dataToDisplay?.filter((item: any) => {
    if (filter === "employed") {
      return item.employmentStatus === "employed";
    } else if (filter === "self-employed") {
      return item.employmentStatus === "selfEmployed";
    } else if (filter === "student") {
      return item.employmentStatus === "student";
    } else if (filter === "outRight") {
      return item.employmentStatus === "outRight";
    } else if (filter === "flexible") {
      return item.employmentStatus === "flexible";
    } else if (filter === "fBadLoan") {
      return item.loanStatus === "fBadLoan";
    } else if (filter === "sBadLoan") {
      return item.loanStatus === "sBadLoan";
    } else if (filter === "") {
      return true;
    }
    return true;
  });



  return (
    <main className="w-full">
      <div className="bg-white rounded-md shadow-md pb-6">
        <div
          className={`w-full overflow-x-auto ${
            isLoading && "animate-pulse h-[50vh]"
          }`}
        >
          <div className="flex gap-10 p-4 mb-6">
            <span
              className={`cursor-pointer pb-2 ${
                activeTab === "individual"
                  ? "border-b-2 border-green-500"
                  : "null"
              }`}
              onClick={() => {
                setActiveTab("individual");
                setCurrentPage(1);
              }}
            >
              Individual
            </span>
            <span
              className={`cursor-pointer pb-2 ${
                activeTab === "stateGovernment"
                  ? "border-b-2 border-green-500"
                  : "null"
              }`}
              onClick={() => {
                setActiveTab("stateGovernment");
                setCurrentPage(1);
              }}
            >
              State Government
            </span>
            <span
              className={`cursor-pointer pb-2 ${
                activeTab === "church" ? "border-b-2 border-green-500" : "null"
              }`}
              onClick={() => {
                setActiveTab("church");
                setCurrentPage(1);
              }}
            >
              Church
            </span>
          </div>
          <div
            className="flex items-center justify-between p-6"
            style={{ minWidth: "700px" }}
          >
            <div className="flex justify-between items-center w-full">
              <h1 className="text-base font-semibold ">Defaulters List</h1>
              <div className="relative md:w-[30rem] w-fit">
                <IoSearchOutline className="w-5 h-5 absolute top-[0.6rem] left-2 text-gray-300" />
                <input
                  type="search"
                  name="searchedUser"
                  id="searchedUser"
                  value={searchedUser}
                  onChange={(e) => searchForUsersWithEmail(e.target.value)}
                  placeholder="Search user using email"
                  className="border text-sm p-2 rounded-md indent-7 w-full disabled:bg-gray-100"
                  disabled={totalResults === 0 && !searchedUser}
                />
              </div>

              <div>
                <label htmlFor="filterOccupation">
                  <select
                    name="filterOccupation"
                    id="filterOccupation"
                    className="border p-2 ml-4 text-sm"
                    onChange={(e) => setFilter(e.target.value)}
                  >
                    <option value="">Filter by account type</option>
                    {activeTab === "individual" ? (
                      <>
                        <option value="employed">Employed</option>
                        <option value="self-employed">Self-employed</option>
                        <option value="student">Students</option>
                      </>
                    ) : activeTab === "stateGovernment" ? (
                      <>
                        <option value="outRight">Outright</option>
                        <option value="flexible">Flexible</option>
                        <option value="fBadLoan">Owing 1 Installment</option>
                        <option value="sBadLoan">Owing 2 Installments</option>
                      </>
                    ) : (
                      <>
                        <option value="outRight">Outright</option>
                        <option value="flexible">Flexible</option>
                      </>
                    )}
                  </select>
                </label>
              </div>
            </div>
          </div>
          <section className="overflow-x-auto">
            <table className="md:w-[1350px] w-[700px] my-3 text-sm text-nowrap">
              <thead className="bg-gray-50 font-bold text-left p-4">
                <tr>
                  <th className="p-2 ">S/N</th>
                  <th className="p-2 ">Full name</th>
                  <th className="p-2">Email</th>
                  <th className="p-2">Account Type</th>
                  <th className="p-2">Phone number</th>
                  <th className="p-2">Contact</th>
                  <th className="p-2">Action</th>
                  <th className="p-2">BVN</th>
                  <th className="p-2">Loan Information</th>
                  {adminLevel === "superadmin" && (
                    <th className="p-2">Action</th>
                  )}
                </tr>
              </thead>
              <tbody>
                {isLoading ? (
                  <tr>
                    <td colSpan={12} className="text-center p-3">
                      <LoadingSpinner />
                    </td>
                  </tr>
                ) : finalFilteredData && finalFilteredData.length > 0 ? (
                  finalFilteredData.map((data: any, index: any) => (
                    <tr className="border-b border-gray-300" key={index}>
                      <td className="text-secondary py-4 px-2">
                        {index + ((currentPage - 1) * itemsPerPage + 1)}
                      </td>
                      <td className="py-4 px-2 capitalize">
                        {data.firstName.toLowerCase() +
                          " " +
                          data.lastName.toLowerCase()}
                      </td>
                      <td className="py-4 px-2">{data.email}</td>
                      <td className="py-4 px-2 capitalize">
                        {data.employmentStatus}
                      </td>
                      <td className="py-4 px-2">{data.phoneNumber}</td>
                      <td className="p-2 py-4 ">
                        <button
                          type="button"
                          className="mr-3"
                          title="call customer"
                        >
                          <a href={`tel:${data?.phoneNumber}`}>
                            <FaPhone />
                          </a>
                        </button>
                        <button type="button" title="text via whatsapp">
                          <a
                            href={`https://wa.me/${data?.phoneNumber?.replace(
                              /^0/,
                              "234"
                            )}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <FaWhatsapp />
                          </a>
                        </button>
                      </td>

                      <td className="py-4 px-2">
                        <button
                          disabled={
                            data.cards === "No cards attached to this user"
                          }
                          onClick={() =>
                            handleCardDebit(data.userId, data.defaultAmount)
                          }
                          className={`${
                            data.cards === "No cards attached to this user"
                              ? "bg-gray-200 text-black"
                              : "bg-secondary text-white"
                          } p-2 text-sm rounded-md`}
                        >
                          {data.cards === "No cards attached to this user"
                            ? "No Card"
                            : "Card debit"}
                        </button>
                      </td>
                      <td className="py-4 px-2">
                        <button
                          onClick={() => handleBvnClick(data.userId)}
                          className="text-blue-500 hover:underline focus:outline-none"
                        >
                          {data.bvn}
                        </button>
                      </td>
                      <td className="py-4 px-2 flex justify-center items-center">
                        <button
                          type="button"
                          className="text-secondary text-sm"
                          onClick={() => handleShowLoanInfo(data)}
                        >
                          View
                        </button>
                      </td>
                      {adminLevel === "superadmin" && (
                        <td className="py-4 px-2">
                          <button
                            type="button"
                            className="bg-secondary text-white text-sm rounded-md p-2 w-40"
                            onClick={() =>
                              handleEmandate(
                                data.monoId,
                                data.defaultAmount,
                                index
                              )
                            }
                          >
                            {isLoadingEmandate[index] ? (
                              <Preloader />
                            ) : (
                              "e-mandate debit"
                            )}
                          </button>
                        </td>
                      )}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={12}
                      className="text-center p-6 text-secondary font-medium"
                    >
                      {searchedUser.length > 0 ? (
                        "User not found"
                      ) : filter !== "" ? (
                        <span>
                          No defaulters found matching{" "}
                          <span className="font-bold">
                            "
                            {filter === "fBadLoan"
                              ? "Owing 1 Installment"
                              : filter === "sBadLoan"
                              ? "Owing 2 Installments"
                              : filter === "employed"
                              ? "Employed"
                              : filter === "self-employed"
                              ? "Self-employed"
                              : filter === "student"
                              ? "Students"
                              : filter === "outRight"
                              ? "Outright"
                              : filter === "flexible"
                              ? "Flexible"
                              : filter}
                            "
                          </span>
                        </span>
                      ) : (
                        "No defaulters found"
                      )}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </section>
        </div>
      </div>
      <section className="py-3">
        <Pagination
          length={totalResults}
          itemsPerPage={itemsPerPage}
          handlePagination={goToPage}
          currentPage={currentPage}
          responseTotalPages={totalPages}
          prevPage={prevPage}
          nextPage={nextPage}
        />
      </section>
      {showLoanDetails && (
        <LoanInfo
          loanDetails={loanDetails}
          closeModal={() => setShowLoanDetails(false)}
        />
      )}
      {emandateModal && (
        <EMandateModal
          setEMandateModal={setEmandateModal}
          defaultAmount={defaultAmount}
          acctClick={acctClick}
        />
      )}
      {bvnModalOpen && (
        <BVNVerificationModal
          setBvnModalOpen={setBvnModalOpen}
          selectedBvn={selectedBvn}
          acctClick={acctClick}
        />
      )}
      {cardDebitModal && (
        <CardDebit
          defaultAmount={defaultAmount}
          allCards={allCards}
          setCardDebitModal={setCardDebitModal}
        />
      )}
    </main>
  );
};
